import React from "react";
import { Link } from "react-router-dom";
import { Crown, ArrowRight } from "@phosphor-icons/react";

/**
 * PremiumGate — plan-aware usage strip for AI tools.
 * Shows today's usage vs. the free/premium limit and an upsell when the free
 * allowance is gone (Premium = Voice Pro or VIP; limits are set in Admin → Revenue).
 */
export default function PremiumGate({ used, limit, unit = "today", isPremium = false, testid = "premium-gate" }) {
  const left = Math.max(0, (limit || 0) - (used || 0));
  const exhausted = limit > 0 && left === 0;
  const pct = limit > 0 ? Math.min(100, Math.round(((used || 0) / limit) * 100)) : 0;
  return (
    <div className={`rounded-2xl border p-3 ${exhausted && !isPremium ? "bg-jam-gold/10 border-jam-gold/40" : "bg-white/5 border-white/10"}`} data-testid={testid}>
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="text-cream/50 text-[10px] tracking-[0.25em] uppercase font-bold">{isPremium ? "Premium plan" : "Free plan"}</p>
          <p className="text-cream text-sm font-bold" data-testid={`${testid}-usage`}>{(used || 0).toLocaleString()} / {(limit || 0).toLocaleString()} {unit}</p>
        </div>
        {isPremium ? (
          <span className="inline-flex items-center gap-1 text-[10px] font-black tracking-[0.2em] uppercase px-2.5 py-1 rounded-full bg-jam-gold text-jam-black"><Crown size={11} weight="fill" /> Premium</span>
        ) : (
          <Link to="/shop" data-testid={`${testid}-upgrade`} className={`inline-flex items-center gap-1 text-[10px] font-black tracking-[0.2em] uppercase px-3 py-1.5 rounded-full ${exhausted ? "bg-jam-gold text-jam-black" : "bg-white/10 text-cream"}`}>
            <Crown size={11} weight="fill" /> {exhausted ? "Go Premium" : "Upgrade"} <ArrowRight size={10} weight="bold" />
          </Link>
        )}
      </div>
      <div className="mt-2 h-1.5 rounded-full bg-white/10 overflow-hidden">
        <div className={`h-full rounded-full transition-all ${exhausted ? "bg-jam-gold" : "bg-papaya"}`} style={{ width: `${pct}%` }} />
      </div>
      {exhausted && !isPremium && <p className="text-cream/60 text-[11px] mt-1.5">Free allowance used for today. VIP or Voice Pro members get higher daily limits on every AI tool.</p>}
    </div>
  );
}
